import React, { useMemo, useState } from "react";
import { Form as FinalForm, Field as FinalField } from "react-final-form";
import { Menu, List, Popup, Header, Form as SemanticForm, Modal, Button } from "semantic-ui-react";
import { Role } from "../../types/roles";
import { SelectInput } from "../../utils/components";
import { required } from "../../utils/formValidation";

type RegionSelectorProps = {
  selectedRole: Role;
  onSubmit: (role: Role) => any;
  availableRoles: Role[];
  isPencilerUser: boolean;
};

const RegionSelector = ({
  selectedRole,
  onSubmit,
  availableRoles,
  isPencilerUser
}: RegionSelectorProps) => {
  const [open, setOpen] = useState(false);
  const submitAndClose = ({ role }: { role: number }) => {
    const value = availableRoles.find(({ id }) => role === id) as Role;
    onSubmit(value);
    setOpen(false);
  };

  const options = useMemo(
    () =>
      availableRoles.map(role => ({
        key: role.id,
        text: `${role.region?.name} (${role.region?.modelType} - ${role.region?.id})`,
        value: role.id
      })),
    [availableRoles]
  );

  const defaultRole = useMemo(() => availableRoles.find(role => role.id === selectedRole.id), [
    availableRoles,
    selectedRole.id
  ]);

  const triggerButton = (
    <Menu.Item onClick={() => setOpen(true)}>{defaultRole?.region?.name}</Menu.Item>
  );

  return (
    <Modal
      size="tiny"
      open={open}
      closeIcon
      onClose={() => setOpen(false)}
      trigger={
        isPencilerUser ? (
          triggerButton
        ) : (
          <Popup trigger={triggerButton}>
            <Header as="h4">Region Info</Header>
            <List>
              <List.Item>
                <b>Model:</b> {defaultRole?.region?.modelType}
              </List.Item>
              <List.Item>
                <b>Region ID:</b> {defaultRole?.region?.id}
              </List.Item>
              <List.Item>
                <b>SRS:</b> {defaultRole?.region?.srs}
              </List.Item>
              <List.Item>
                <b>MPO ID:</b> {defaultRole?.region?.mpo_id}
              </List.Item>
              <List.Item>
                <b>Base Year:</b> {defaultRole?.region?.base_year}
              </List.Item>
            </List>
          </Popup>
        )
      }
    >
      <Modal.Header>Select region</Modal.Header>
      <Modal.Content>
        <FinalForm
          onSubmit={submitAndClose}
          render={({ handleSubmit, invalid }) => (
            <SemanticForm onSubmit={handleSubmit} size="large" style={{ textAlign: "left" }}>
              <FinalField
                aria-label="Region selection"
                // @ts-ignore
                component={SelectInput}
                label="Region:"
                name="role"
                required
                placeholder="Select type"
                defaultValue={selectedRole.id}
                validate={required(true)}
                options={options}
              />
              <Button primary type="submit" disabled={invalid}>
                Select
              </Button>
              <Button type="button" onClick={() => setOpen(false)} content="Cancel" />
            </SemanticForm>
          )}
        />
      </Modal.Content>
    </Modal>
  );
};
export default RegionSelector;
